<template>
    <show-manual-pics
    :fileNames="['19.png']"/>
</template>

<script>
import showManualPics from '../components/modules/show-manual-pics.vue';
export default {
  components: { showManualPics },

}
</script>